import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { db } from "../Admin/Config/Config";
import folderImg from "./assets/folder-4.png";

export default function EnglishCourses() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [folders, setFolders] = useState([]);
  const navigate = useNavigate();
  const courseId = searchParams.get("id");
  const fetchFolders = async (q) => {
    const foldersSnap = await getDocs(q);
    const data = [];
    foldersSnap.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });
    setFolders(data);
  };

  useEffect(
    () => {
      const foldersRef = collection(db, "jaffers_english_folders");
      const q = query(
        foldersRef,
        where("course_id", "==", courseId),
        where("status", "==", true),
        orderBy("asc", "asc")
      );
      fetchFolders(q);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [courseId]
  );

  const sortList = (e) => {
    const foldersRef = collection(db, "jaffers_english_folders");
    const q = query(
      foldersRef,
      where("course_id", "==", courseId),
      where("status", "==", true),
      orderBy(e.target.value, e.target.value)
    );
    fetchFolders(q);
  };

  const handleNavigation = (course) => {
    if (courseId && course.id) {
      navigate(`/view-course?id=${courseId}&fId=${course.id}`);
    }
  };
  // ========= Image on Load ========= //
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    setHasError(false);
  }, []);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    setIsLoading(false);
    setHasError(true);
  };
  return (
    <div className="max-w-7xl px-4 sm:px-6 lg:px-12 py-8 md:py-10 mx-auto min-h-screen">
      <div className="mb-6 flex flex-col md:flex-row md:items-center justify-end space-y-3 md:space-y-0 md:space-x-4">
        <label
          htmlFor="sort"
          className="md:mr-3 self-start md:self-center text-gray-100 text-lg font-medium"
        >
          Sort by:
        </label>
        <select
          id="sort"
          onChange={sortList}
          className="p-3 rounded-lg bg-black text-gray-100 border  border-gray-00 focus:outline-none transition w-full md:w-auto"
        >
          <option disabled selected>
            Sort Options
          </option>
          <option value={"asc"}>ASC</option>
          <option value={"desc"}>DESC</option>
        </select>
      </div>

      <div className="space-y-8">
        {folders &&
          folders.map((course) => (
            <div key={course.id}>
              {course.style === "folder" ? (
                <div
                  onClick={() => handleNavigation(course)}
                  className="bg-black border border-gray-800 shadow-md rounded-lg flex flex-col md:flex-row overflow-hidden transform transition-all duration-300 hover:shadow-2xl hover:-translate-y-1"
                >
                  <div className="w-full md:w-1/3 h-48 justify-center items-center  flex md:h-auto">
                    <>
                      {isLoading && !hasError && (
                        <img
                          src={folderImg}
                          alt="Loading..."
                          className="w-22 h-22 object-cover"
                        />
                      )}
                      <img
                        src={course.img_url || folderImg}
                        alt={course.title}
                        className={`w-22 h-22 object-cover ${
                          isLoading && !hasError ? "hidden" : ""
                        }`}
                        onLoad={handleImageLoad}
                        onError={handleImageError}
                      />
                    </>
                  </div>

                  <div className="w-full md:w-2/3 p-4 md:p-6 flex flex-col justify-between">
                    <div>
                      <h2 className="text-xl md:text-2xl font-semibold text-gray-100">
                        {course.title}
                      </h2>
                      <p className="text-sm text-gray-300 mt-2 leading-relaxed">
                        {course.subtitle}
                      </p>
                    </div>

                    <div className="mt-5 flex flex-col md:flex-row md:justify-between items-start md:items-center space-y-4 md:space-y-0">
                      <div className="text-sm font-medium text-gray-300">
                        🎬 {course.video_count} Videos
                      </div>
                      <button
                        onClick={() => handleNavigation(course)}
                        className="px-5 py-2 bg-gradient-to-r from-emerald-700 to-emerald-800 text-white rounded-lg text-sm font-semibold shadow-md transition-all duration-300 hover:opacity-90 hover:shadow-lg w-full md:w-auto text-center"
                      >
                        Start Learning →
                      </button>
                    </div>
                  </div>
                </div>
              ) : course.style === "title" ? (
                <h1 className="text-2xl md:text-3xl font-bold text-gray-100 mt-6 mb-4">
                  {course.title}
                </h1>
              ) : null}
            </div>
          ))}
      </div>
    </div>
  );
}
